import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Grid, Box, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PrepagoV2 from './components/PrepagoV2';

export default function Prepaid() {
  const profile = useSelector((state) => state.firebase.profile);
  const useStyles = () => {
    return makeStyles((theme) => ({
      appBarSpacer: theme.mixins.toolbar,
      chart: {
        paddingBottom: 64,
      },
    }));
  };

  const isAdmin = profile && profile.claims && profile.claims.includes('admin');
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  return (
    <Container maxWidth="lg">
      <Box pb={4}>
        <Grid container display="flex" justifyContent="center">
          <Grid item xs={12} sm={10}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg">
              {isAdmin && <PrepagoV2 />}
              {!isAdmin && <h1>No posee permisos de administrador</h1>}
            </Container>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
